import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { makeStyles, useTheme } from '@material-ui/styles';
import { Button, Grid, Typography } from '@material-ui/core';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import { MessageValues } from '../../values/MessageValues';
import InputMask from 'react-input-mask';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { EstadoCivilValues } from '../../values/EstadoCivilValues';
import MenuItem from '@material-ui/core/MenuItem';
import { Values } from '../../values/Values';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const schema = {
  email: {
    presence: { allowEmpty: false, message: 'is required' },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'is required' },
    length: {
      maximum: 128
    }
  }
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: '100%',
  },
  grid: {
    height: '100%'
  },
  quoteContainer: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  quote: {
    backgroundColor: theme.palette.neutral,
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: 'url(/images/auth03.jpeg)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',

  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: theme.palette.white,
    fontWeight: 300
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.white
  },
  bio: {
    color: theme.palette.white
  },
  contentContainer: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  logoImage: {
    marginLeft: theme.spacing(4)
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    paddingLeft: 100,
    paddingRight: 100,
    paddingBottom: 125,
    flexBasis: 700,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },
  socialButtons: {
    marginTop: theme.spacing(3)
  },
  socialIcon: {
    marginRight: theme.spacing(1)
  },
  sugestion: {
    marginTop: theme.spacing(2)
  },
  textField: {
    marginTop: theme.spacing(2)
  },
  signInButton: {
    margin: theme.spacing(2, 0)
  },
  logo: {
    padding: theme.spacing(5),
    marginTop: '10%',
    marginLeft: '10%'
  },

  rootCardSuccess: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(4)
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  contentCardSuccess: {
    flex: '1 0 auto',
  },
  cover: {
    width: 151,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
}));

const PreInscricao = props => {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const { history } = props;
  const theme = useTheme();
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');

  const [filiado, setFiliado] = useState(
    {
      nome: '',
      rg: '',
      orgaoExpedidor: '',
      dataExpedicao: null,
      cpf: '',
      dataNascimento: null,
      estadoCivil: '',
      profissao: '',
      nomeMae: '',
      nomePai: '',
      email: '',
      numeroCr: '',
      validadeCr: null,
      idFiliacaoStatus: Values.FiliacaoStatusValues.pendente,
      idGrupoSanguineo: '',
      enderecos: [],
      telefones: [],
      visitas: []
    }
  );
  const [nome, setNome] = useState();
  const [cpf, setCpf] = useState();
  const [rg, setRg] = useState();
  const [orgaoExpedidor, setOrgaoExpedidor] = useState();
  const [dataExpedicao, setDataExpedicao] = useState(null);
  const [dataNascimento, setDataNascimento] = useState(null);
  const [profissao, setProfissao] = useState();
  const [estadoCivil, setEstadoCivil] = useState();
  const [nomePai, setNomePai] = useState();
  const [nomeMae, setNomeMae] = useState();
  const [email, setEmail] = useState();
  const [numeroCr, setCr] = useState();
  const [validadeCr, setValidadeCr] = useState(null);
  const [idFiliacaoStatus, setIdFiliacaoStatus] = useState();
  const [idGrupoSanguineo, setIdGrupoSanguineo] = useState();
  const [gruposSanguineos, setGruposSanguineos] = useState({
    result: []
  });
  const [maskCpf] = useState('999.999.999-99');
  const classes = useStyles();
  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);

  useEffect(() => {
    async function carregarGruposSanguines() {
      try{
        setLoading(true);
        const params = {
          limit: 100,
        };
        const dados = await api.get('grupo-sanguineo/', {params: params});
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length !== 0){
            setGruposSanguineos(dados.data);
          }
          else{
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Não há grupos sanguíneos.');
            setShowMessageSnack(true);
          }
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Não foi possível obter os grupos sanguíneos. Contate o suporte.');
          setShowMessageSnack(true);
        }

      }
      catch (e) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(MessageValues.erro_catch);
        setShowMessageSnack(true);
      }
    }
    carregarGruposSanguines();
  }, []);

  const handleBack = () => {
    history.goBack();
  };

  const handleChange = event => {
    event.persist();

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true
      }
    }));
  };

  const handleSignIn = async event => {
    event.preventDefault();
    try{
      setLoading(true);
      filiado.cpf = filiado.cpf.replace(".", "");
      filiado.cpf = filiado.cpf.replace(".", "");
      filiado.cpf = filiado.cpf.replace("-", "");
      let filiadoPost = await api.post('/filiados/', filiado);
      if(filiadoPost){
        if(filiadoPost.data.isSuccess){
          setLoading(false);
          setSuccess(true);


        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack(filiadoPost.data.message);
          setShowMessageSnack(true);
        }
      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(Values.MessageValues.erro_catch);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
      setShowMessageSnack(true);
    }
  };

  const hasError = field =>
    formState.touched[field] && formState.errors[field] ? true : false;

  const handleClickShowPassword = () => {
    setMostrarSenha(!mostrarSenha);
  };

  const handleChangeDatNascimento = date => {
    filiado.dataNascimento = date;
    setFiliado(filiado);
    setDataNascimento(date);
  };

  const handleChangeDataExpedicao = date => {
    filiado.dataExpedicao = date;
    setFiliado(filiado);
    setDataExpedicao(date);
  };

  const handleChangeValidadeCr = date => {
    filiado.validadeCr = date;
    setFiliado(filiado);
    setValidadeCr(date);
  };

  function modificarValores(order, value){
    switch (order) {
      case 0:
        filiado.nome = value;
        setFiliado(filiado);
        setNome(value);
        break;
      case 1:
        filiado.cpf = value;
        setFiliado(filiado);
        setCpf(value);
        break;
      case 2:
        filiado.rg = value;
        setFiliado(filiado);
        setRg(value);
        break;
      case 3:
        filiado.orgaoExpedidor = value;
        setFiliado(filiado);
        setOrgaoExpedidor(value);
        break;
      case 4:
        filiado.profissao = value;
        setFiliado(filiado);
        setProfissao(value);
        break;
      case 5:
        filiado.estadoCivil = value;
        setFiliado(filiado);
        setEstadoCivil(value);
        break;
      case 6:
        filiado.nomePai = value;
        setFiliado(filiado);
        setNomePai(value);
        break;
      case 7:
        filiado.nomeMae = value;
        setFiliado(filiado);
        setNomeMae(value);
        break;
      case 8:
        filiado.email = value;
        setFiliado(filiado);
        setEmail(value);
        break;
      case 9:
        filiado.numeroCr = value;
        setFiliado(filiado);
        setCr(value);
        break;
        break;
      case 10:
        filiado.idFiliacaoStatus = value;
        setFiliado(filiado);
        setIdFiliacaoStatus(value);
        break;
      case 11:
        filiado.idGrupoSanguineo = value;
        setFiliado(filiado);
        setIdGrupoSanguineo(value);
        break;
    }
  }

  return (
    <div className={classes.root}>
      <ProgressFullScreen
        open={loading}
        setOpen={setLoading}
      />
      <SnackbarCustom
        verticalOrientation='bottom'
        horizontalOrientation='center'
        open={showMessageSnack}
        setOpen={setShowMessageSnack}
        message={messageSnack}
        duration={2000}
        type={typeSnack}
      />
      {success ?
        //---------------------------------MENSAGEM SUCESSO --------------------------------------------------------

          <Grid
            container
            spacing={3}
            className={classes.rootCardSuccess}
          >
            <Grid
              item
              md={3}
            />
            <Grid
              item
              md={6}
              xs={12}


            >
              <Card >
                <div
                  style={{
                    backgroundColor: "#295138",
                    height: 140,
                    display: 'flex',
                    flexWrap: 'wrap',
                    paddingLeft: '45%',
                    paddingTop: '7%'

                  }}
                >
                  <div
                    style={{

                    }}
                  >
                    <CheckCircleIcon
                      style={{
                        fontSize: 50,
                        color:'white'
                      }}
                    />

                  </div>

                </div>
                <CardContent>
                  <Typography gutterBottom variant="h5" component="h2">
                    Pré-inscrição realizada com sucesso.
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    Os pré-inscritos receberão um email informando a data e o local para finalizarem a sua filiação
                    CLUBE DE TIRO GARANHUNS - CTG.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid
              item
              md={3}
            />


          </Grid>



        //----------------------------------------------------------------------------------------------------------
        :
        //---------------------------- FORMULARIO -------------------------------------------------------------------
        <div className={classes.root}>

        <ValidatorForm
          className={classes.form}
          autoComplete="off"
          onSubmit={handleSignIn}

        >
          <Typography
            className={classes.title}
            variant="h2"
          >
            Pré-inscrição
          </Typography>

          <Typography
            align="center"
            className={classes.sugestion}
            color="textSecondary"
            variant="body1"
          >
            Preencha os dados do formulário a seguir para efetuar sua pré-inscrição
          </Typography>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={7}
              sm={7}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Nome completo"
                helperText="Insira o nome completo."
                margin="dense"
                name="nome_filiado"
                onChange={e => modificarValores(0, e.target.value)}
                value={nome}
                variant="outlined"
                validators={['required', 'minStringLength:3', 'maxStringLength:155']}
                errorMessages={['Insira o nome completo.', 'Nome muito curto.', 'Nome muito longo.']}
              />
            </Grid>
            <Grid
              item
              md={5}
              sm={5}
              xs={12}
            >

              <InputMask
                mask={maskCpf}
                value={cpf}
                onChange={e => modificarValores(1, e.target.value)}
              >
                {
                  (inputProps) =>
                    <TextValidator
                      fullWidth
                      label="CPF"
                      margin="dense"
                      name="cnpj"
                      onChange={inputProps.onChange}
                      type="text"
                      variant="outlined"
                      helperText="Insira o CPF."
                      validators={['required']}
                      errorMessages={['Insira o CPF.']  }
                    />

                }
              </InputMask>
            </Grid>
            <Grid
              item
              md={3}
              sm={4}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="RG"
                helperText="Insira o RG."
                margin="dense"
                name="rg"
                onChange={e => modificarValores(2, e.target.value)}
                value={rg}
                variant="outlined"
                validators={['required',]}
                errorMessages={['Insira o RG.']}
              />
            </Grid>
            <Grid
              item
              md={3}
              sm={4}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Orgão Expeditor"
                helperText="Insira o Orgão Expedidor."
                margin="dense"
                name="rg"
                onChange={e => modificarValores(3, e.target.value)}
                value={orgaoExpedidor}
                variant="outlined"
                validators={['required',]}
                errorMessages={['Insira o RG.']}
              />
            </Grid>
            <Grid
              item
              md={3}
              sm={4}
              xs={12}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    fullWidth
                    margin="dense"
                    inputVariant="outlined"
                    orientation="landscape"
                    id="dataExpedicao"
                    label="Data de Expedição"
                    helperText={'Insira a data de expedição do RG'}
                    format="dd/MM/yyyy"
                    size='small'
                    value={dataExpedicao}
                    onChange={handleChangeDataExpedicao}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    InputAdornmentProps={{ position: "end" }}
                  />

                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid
              item
              sm={4}
              md={3}
              xs={12}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    fullWidth
                    margin="dense"
                    inputVariant="outlined"
                    orientation="landscape"
                    id="dataNascimento"
                    label="Data de Nascimento"
                    helperText={'Insira a data de nascimento'}
                    format="dd/MM/yyyy"
                    size='small'
                    value={dataNascimento}
                    onChange={handleChangeDatNascimento}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    InputAdornmentProps={{ position: "end" }}
                  />

                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid
              item
              sm={4}
              md={6}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Profissão"
                helperText="Insira a sua profissão."
                margin="dense"
                name="profissao"
                onChange={e => modificarValores(4, e.target.value)}
                value={profissao}
                variant="outlined"
                validators={['required', 'maxStringLength:100']}
                errorMessages={['Insira a sua profissão.', 'Profissão muito longa.']}
              />
            </Grid>
            <Grid
              item
              sm={4}
              md={6}
              xs={12}
            >
              <SelectValidator
                fullWidth
                helperText="Insira o estado civil."
                label="Estado civil"
                margin="dense"
                name="estadoCivil"
                onChange={e => modificarValores(5, e.target.value)}
                value={estadoCivil}
                variant="outlined"
                validators={['required']}
                errorMessages={['Insira o estado civil.']}
              >
                {EstadoCivilValues.map((estado, index) => (
                  <MenuItem key={index} value={estado.value}>{estado.label}</MenuItem>
                ))}

              </SelectValidator>

            </Grid>
            <Grid
              item
              sm={6}
              md={6}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Nome do pai"
                helperText="Insira o nome do seu pai."
                margin="dense"
                name="nomePai"
                onChange={e => modificarValores(6, e.target.value)}
                value={nomePai}
                variant="outlined"
                validators={['required']}
                errorMessages={['Insira o nome do seu pai.']}
              />
            </Grid>
            <Grid
              item
              sm={6}
              md={6}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Nome da mãe"
                helperText="Insira o nome da sua mãe."
                margin="dense"
                name="nomeMae"
                onChange={e => modificarValores(7, e.target.value)}
                value={nomeMae}
                variant="outlined"
                validators={['required']}
                errorMessages={['Insira o nome da sua mãe.']}
              />
            </Grid>
            <Grid
              item
              sm={12}
              md={6}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="Email"
                helperText="Insira seu email."
                margin="dense"
                name="email"
                onChange={e => modificarValores(8, e.target.value)}
                value={email}
                variant="outlined"
                validators={['required', 'isEmail']}
                errorMessages={['Insira seu email.', 'Informe um email válido.']}
              />
            </Grid>
            <Grid
              item
              sm={6}
              md={3}
              xs={12}
            >
              <TextValidator
                fullWidth
                label="CR"
                helperText="Insira o número da sua Certificação de Registro."
                margin="dense"
                name="email"
                onChange={e => modificarValores(9, e.target.value)}
                value={numeroCr}
                variant="outlined"
                validators={['required']}
                errorMessages={['Insira o número da sua Certificação de Registro.']}
              />
            </Grid>
            <Grid
              item
              sm={6}
              md={3}
              xs={12}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    fullWidth
                    margin="dense"
                    inputVariant="outlined"
                    orientation="landscape"
                    helperText={'Insira a data de validade da sua Certificação de Registro.'}
                    id="validadeCr"
                    label="Validade CR"
                    format="dd/MM/yyyy"
                    size='small'
                    value={validadeCr}
                    onChange={handleChangeValidadeCr}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                    InputAdornmentProps={{ position: "end" }}
                  />

                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid
              item
              sm={12}
              md={12}
              xs={12}
            >
              <SelectValidator
                fullWidth
                helperText="Insira o seu tipo sanguíneo."
                label="Grupo Sanguíneo"
                margin="dense"
                name="tipo_sanguineo"
                onChange={e => modificarValores(11, e.target.value)}
                value={idGrupoSanguineo}
                variant="outlined"
                validators={['required']}
                errorMessages={['Insira o seu tipo sanguíneo.']}
              >
                {gruposSanguineos.result.map((tipo, index) => (
                  <MenuItem key={index} value={tipo.idGrupoSanguineo}>{tipo.descricao}</MenuItem>
                ))}
              </SelectValidator>
            </Grid>
          </Grid>

          <Button
            className={classes.signInButton}
            color="primary"
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            Finalizar
          </Button>
        </ValidatorForm>
        </div>
      }
    </div>
  );
};

PreInscricao.propTypes = {
  history: PropTypes.object
};

export default withRouter(PreInscricao);
